import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiChevronDown } from 'react-icons/fi';
import './Navbar.css';
import logo from './cresent-2.png'; // Import the logo from the same folder

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setActiveDropdown(null);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { 
      path: '/advisory-scope', 
      label: 'Advisory Scope',
      dropdown: [
        { path: '/advisory-scope#energy', label: 'Energy & Oil' },
        { path: '/advisory-scope#commodities', label: 'Commodities & Mining' },
        { path: '/advisory-scope#real-estate', label: 'Real Estate' },
        { path: '/advisory-scope#joint-ventures', label: 'Joint Ventures' }
      ]
    },
    { path: '/engagement-process', label: 'Engagement Process' },
    { path: '/counterparty-profile', label: 'Counterparty Profile' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img src={logo} alt="Crescent Advisory Ltd" className="logo-image" />
        </Link>

        <div className="nav-links-desktop">
          {navLinks.map((link) => (
            <div
              key={link.path}
              className="nav-item"
              onMouseEnter={() => link.dropdown && setActiveDropdown(link.path)}
              onMouseLeave={() => setActiveDropdown(null)}
            >
              <Link
                to={link.path}
                className={`nav-link ${location.pathname === link.path ? 'active' : ''} ${link.dropdown ? 'has-dropdown' : ''}`}
              >
                {link.label}
                {link.dropdown && <FiChevronDown className={`dropdown-icon ${activeDropdown === link.path ? 'rotated' : ''}`} />}
              </Link>
              {link.dropdown && activeDropdown === link.path && (
                <div className="dropdown-menu">
                  {link.dropdown.map((item) => (
                    <Link key={item.path} to={item.path} className="dropdown-item">
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
          <Link to="/investor-portal" className="nav-portal-button">
            Investor Portal
          </Link>
        </div>

        <button className="nav-mobile-toggle" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FiX /> : <FiMenu />}
        </button>

        <div className={`nav-mobile-menu ${isOpen ? 'open' : ''}`}>
          {navLinks.map((link) => (
            <React.Fragment key={link.path}>
              <Link
                to={link.path}
                className={`nav-mobile-link ${location.pathname === link.path ? 'active' : ''}`}
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </Link>
              {link.dropdown && link.dropdown.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="nav-mobile-sub-link"
                  onClick={() => setIsOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </React.Fragment>
          ))}
          <Link to="/investor-portal" className="nav-mobile-portal" onClick={() => setIsOpen(false)}>
            Investor Portal
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;